export default __webpack_public_path__ + "static/media/Amplitude-LightItalic.91cee8d7.otf";